// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isOpenAiLiquidAssistantResult = objectOf({
  error: boolean,
  error_message: string,
  message: string,
  response: string,
});
